import React, { useEffect, useState } from "react";
import { options, emailNameOnly } from "../../../utils/common";
import DropdownIndicator from "../DropdownIndicator";

import CreatableSelect from 'react-select/creatable';

function InputEmail(props) {

    const { register, errors, getValues, setValue, setError, selectedValue, color, disabled, onChange, required = true, clearEmailNameOnDomainSelect = false } = props;

    const [emailName, setEmailName] = useState(null);
    const [emailSource, setEmailSource] = useState(null);
    const [mailOptions, setMailOptions] = useState(options.mails);

    const selectStyle = {
        control: (base) => ({
            ...base,
            borderColor: 'transparent !important',
            boxShadow: 'none',
            minHeight: 18
        }),
        singleValue: (base) => ({
            ...base,
            color: '#FD9F40',
            paddingBottom: 0
        }),
        valueContainer: (base) => ({
            ...base,
            padding: 0,
        }),
        indicatorSeparator: (base) => ({
            ...base,
            display: 'none',
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: '#FD9F40',
            padding: 0
        }),
        placeholder: (base) => ({
            ...base,
            color: '#8E8E8E',
            textAlign: 'center'
        }),
    }

    useEffect(() => {
        if (selectedValue) {
            const emailArr = selectedValue.split('@');
            if (emailArr.length > 0) {
                const email_name = emailNameOnly(emailArr[0]);
                const email_source = {label: emailArr[1], value: `@${emailArr[1]}`};
                setEmailName(email_name);
                setEmailSource(email_source);
                setValue('email_name', email_name);
                setValue('email_source', email_source);
            }
        }
    }, [selectedValue]);

    const onValueChange = () => {
        const email_name = getValues('email_name') ?? '';
        const email_source = (getValues('email_source')?.value ?? '').replace('@', '');
        const email = email_name.includes('@') ? email_name : ((email_name && email_source) ? `${email_name}@${email_source}` : null);
        onChange(email);
    }

    const handleCreate = (inputValue, bypass = false, { clearEmailName = false } = {}) => {
        if (!mailOptions.some((option) => option.value === inputValue) || bypass) {
            const newOption = { value: inputValue, label: inputValue.replace('@', ''), name: inputValue.replace('@', '')};
            setEmailSource(newOption);
            if(!bypass){
                setMailOptions([...mailOptions, newOption]);
            }
            setValue('email_source', newOption);
            setError('email_source', null);

            if (clearEmailName) {
                setEmailName('');
                setValue('email_name', '');
                setError('email_name', null);
                onChange(null);
                return;
            }

            onValueChange();
        }
    };

    const handleInputChange = (inputValue, bypass = false) => {
        if (inputValue.trim()) {
            handleCreate(inputValue.trim(), bypass);
        }
    };

    return (
        <div className="flex w-full items-center justify-center ">
            <div className="w-1/2 pr-2 border-b border-primary mr-2 pb-1">
                <input disabled={disabled} value={emailName ?? ''} {...register('email_name', {
                    required,
                    onChange: (e) => {
                        e.target.value = emailNameOnly(e?.target?.value);
                        setEmailName(e.target.value);
                        setValue('email_name', e.target.value);
                        setError('email_name', null);
                        onValueChange();
                    }
                })} placeholder="Example" className="flex-1 mt-1 pb-[3px] outline-none text-primary w-full" />
            </div>
            <div className="mb-[-15px] mr-[5px] text-primary text-center">
                <span>@</span>
            </div>
            <div className="w-1/2 pl-2 border-b border-primary">
                <CreatableSelect
                    isDisabled = {disabled}
                    placeholder="- 請選擇 -"
                    className="w-full"
                    theme={(theme) => ({
                        ...theme, borderRadius: 0, minHeight: 25
                    })}
                    styles={selectStyle}
                    {...register('email_source')}
                    options={options.mails}
                    onChange={(e)=>{
                        handleCreate(e?.value, true, { clearEmailName: clearEmailNameOnDomainSelect });
                    }}
                    components={{ DropdownIndicator }}
                    onInputChange={handleInputChange}
                    value={emailSource}
                />
            </div>
        </div>
    );
}

export default InputEmail;
